import React from 'react'

const Home = React.lazy(() => import('./karuna/Home'))
const Projects = React.lazy(() => import('./karuna/Projects'))
const Projectsdetails = React.lazy(() => import('./karuna/Projectsdetails'))
const Event = React.lazy(() => import('./karuna/Event'))
const Eventdetails = React.lazy(() => import('./karuna/Eventdetails'))
const Galleryone = React.lazy(() => import('./karuna/Galleryone'))
const Gallerytwo = React.lazy(() => import('./karuna/Gallerytwo'))
const News = React.lazy(() => import('./karuna/News'))
const Newsdetails = React.lazy(() => import('./karuna/Newsdetails'))
const Aboutus = React.lazy(() => import('./karuna/PagesMenus/Aboutus'))
const Error = React.lazy(() => import('./karuna/PagesMenus/error'))
const Faq = React.lazy(() => import('./karuna/PagesMenus/Faq'))
const Login = React.lazy(() => import('./karuna/PagesMenus/Login'))
const Makedonation = React.lazy(() => import('./karuna/PagesMenus/Makedonation'))
const PrivacyPolicy = React.lazy(() => import('./karuna/PagesMenus/PrivacyPolicy'))
const Register = React.lazy(() => import('./karuna/PagesMenus/Register'))
const TermsService = React.lazy(() => import('./karuna/PagesMenus/TermsService'))
const Testimonial = React.lazy(() => import('./karuna/PagesMenus/Testimonial'))
const Volunter = React.lazy(() => import('./karuna/PagesMenus/Volunter'))
const Contact = React.lazy(() => import('./karuna/Contact'))
const Reachus = React.lazy(() => import('./karuna/Reachus'))
const Summary = React.lazy(() => import('./karuna/Summary'))
const Taxation = React.lazy(() => import('./karuna/Taxation'))
// high octaves routes

const Home1 = React.lazy(() => import('./high_octavez/Homemusic'))
const Projects1 = React.lazy(() => import('./high_octavez/Projects'))
const Projectsdetails1 = React.lazy(() => import('./high_octavez/Projectsdetails'))
const Event1 = React.lazy(() => import('./high_octavez/Event'))
const Eventdetails1 = React.lazy(() => import('./high_octavez/Eventdetails'))
const Galleryone1 = React.lazy(() => import('./high_octavez/Galleryone'))
const Socialmedia = React.lazy(() => import('./high_octavez/Socialmedia'))
const News1 = React.lazy(() => import('./high_octavez/News'))
const Newsdetails1 = React.lazy(() => import('./high_octavez/Newsdetails'))
const Aboutus1 = React.lazy(() => import('./high_octavez/PagesMenus/Aboutus'))
const Error1 = React.lazy(() => import('./high_octavez/PagesMenus/error'))
const Faq1 = React.lazy(() => import('./high_octavez/PagesMenus/Faq'))
const Login1 = React.lazy(() => import('./high_octavez/PagesMenus/Login'))
const Makedonation1 = React.lazy(() => import('./high_octavez/PagesMenus/Makedonation'))
const PrivacyPolicy1 = React.lazy(() => import('./high_octavez/PagesMenus/PrivacyPolicy'))
const Register1 = React.lazy(() => import('./high_octavez/PagesMenus/Register'))
const TermsService1 = React.lazy(() => import('./high_octavez/PagesMenus/TermsService'))
const Testimonial1 = React.lazy(() => import('./high_octavez/PagesMenus/Testimonial'))
const Volunter1 = React.lazy(() => import('./high_octavez/PagesMenus/Volunter'))
const Contact1 = React.lazy(() => import('./high_octavez/Contact'))
const Performersmusic = React.lazy(() => import('./high_octavez/Performersmusic'))
const Auditionenquirymusic = React.lazy(() => import('./high_octavez/Auditionenquirymusic'))
const Lives = React.lazy(() => import('./high_octavez/Live'))


// Admin role routes
const Dashboard = React.lazy(() => import('./admin/Dashboard'))
const Adminproject = React.lazy(() => import('./admin/Adminproject'))
const Adminevents = React.lazy(() => import('./admin/Adminevents'))
const Admingallery = React.lazy(() => import('./admin/Admingallery'))
const Adminnews = React.lazy(() => import('./admin/Adminnews'))
const Adminperformer = React.lazy(() => import('./admin/Adminperformer'))
const Adminuser = React.lazy(() => import('./admin/Adminuser'))
const Userole = React.lazy(() => import('./admin/Userole'))
const accessrights = React.lazy(() => import('./admin/Accessrights'))
const Booking = React.lazy(() => import('./admin/Booking'))
const Auditionenquiry = React.lazy(() => import('./admin/Auditionenquiry'))
const Transactiondetials = React.lazy(() => import('./admin/Transactiondetials'))
const Incomeexpenses = React.lazy(() => import('./admin/Incomeexpenses'))
const Adminreport = React.lazy(() => import('./admin/Adminreport'))
const Adminmessage = React.lazy(() => import('./admin/Adminmessage'))
const AdminKarunamessage = React.lazy(() => import('./admin/Adminkarunamessage'))
const AdminReachUs = React.lazy(() => import('./admin/AdminReachUs'))
const Adminkarunagallery = React.lazy(()=>import('./admin/Adminkarunagallery'))
const AdminNewsLetters = React.lazy(()=>import('./admin/NewsLetters'))
const KarunaNewsLetters = React.lazy(()=>import('./admin/NewsLettersKaruna'))
const Admindonation=React.lazy(()=>import('./admin/Admindonation'))
const Admintaxation=React.lazy(()=>import('./admin/Admintaxation'))
const Adminsummary=React.lazy(()=>import('./admin/Adminsummary'))
const Adminlogview=React.lazy(()=>import('./admin/Adminlogview'))
const Admindeletedlog=React.lazy(()=>import('./admin/Admindeletedlog'))
const AdminReport=React.lazy(()=>import('./admin/Report'))
const AdminTitleConfig=React.lazy(()=>import('./admin/TitleConfig'))
const AdminContactInfo= React.lazy(()=>import('./admin/ContactInfo'))
const AdminProfile= React.lazy(()=>import('./admin/Profile'))


const routes = [
    // { path: '/karuna', exact: true, name: 'Home', element3: karunapostermain },
    { path: '/home', exact: true, name: 'Home', element3: Home },
    { path: '/projects', name: 'projects', element3: Projects },
    { path: '/projects_details', name: 'projects_details', element3: Projectsdetails },
    { path: '/Event', name: 'Event', element3: Event },
    { path: '/Event_details', name: 'Event_details', element3: Eventdetails },
    { path: '/gallery_one', name: 'gallery_one', element3: Galleryone },
    { path: '/gallery_two', name: 'gallery_two', element3: Gallerytwo },
    { path: '/news', name: 'news', element3: News },
    { path: '/news_details', name: 'news_details', element3: Newsdetails },
    { path: '/aboutus', name: 'aboutus', element3: Aboutus },
    { path: '/404error', name: '404error', element3: Error },
    { path: '/faq', name: 'faq', element3: Faq },
    { path: '/login', name: 'login', element3: Login },
    { path: '/makedonation', name: 'makedonation', element3: Makedonation },
    { path: '/privacypolicy', name: 'privacypolicy', element3: PrivacyPolicy },
    { path: '/register', name: 'privacypolicy', element3: Register },
    { path: '/termservice', name: 'privacypolicy', element3: TermsService },
    { path: '/testimonial', name: 'privacypolicy', element3: Testimonial },
    { path: '/volunter', name: 'privacypolicy', element3: Volunter },
    { path: '/contact', name: 'privacypolicy', element3: Contact },
    { path: '/reachus', name: 'privacypolicy', element3: Reachus },
    { path: '/summary', name: 'Summary', element3: Summary },
    { path: '/taxation', name: 'Summary', element3: Taxation },


    // high octavez routes paths
    // { path: '/high_octavez/karuna', exact: true, name: 'Home', element: karuna_poster1 },
    { path: '/high_octavez/home', exact: true, name: 'Home', element: Home1 },
    { path: '/high_octavez/projects', name: 'projects', element: Projects1 },
    { path: '/high_octavez/projects_details', name: 'projects_details', element: Projectsdetails1 },
    { path: '/high_octavez/Event', name: 'Event', element: Event1 },
    { path: '/high_octavez/Event_details', name: 'Event_details', element: Eventdetails1 },
    { path: '/high_octavez/gallery_one', name: 'gallery_one', element: Galleryone1 },
    { path: '/high_octavez/Socialmedia', name: 'gallery_two', element: Socialmedia },
    { path: '/high_octavez/news', name: 'news', element: News1 },
    { path: '/high_octavez/news_details', name: 'news_details', element: Newsdetails1 },
    { path: '/high_octavez/aboutus', name: 'aboutus', element: Aboutus1 },
    { path: '/high_octavez/404error', name: '404error', element: Error1 },
    { path: '/high_octavez/faq', name: 'faq', element: Faq1 },
    { path: '/high_octavez/login', name: 'login', element: Login1 },
    { path: '/high_octavez/makedonation', name: 'makedonation', element: Makedonation1 },
    { path: '/high_octavez/privacypolicy', name: 'privacypolicy', element: PrivacyPolicy1 },
    { path: '/high_octavez/register', name: 'register', element: Register1 },
    { path: '/high_octavez/termservice', name: 'termservice', element: TermsService1 },
    { path: '/high_octavez/testimonial', name: 'testimonial', element: Testimonial1 },
    { path: '/high_octavez/volunter', name: 'volunter', element: Volunter1 },
    { path: '/high_octavez/contact', name: 'contact', element: Contact1 },
    { path: '/high_octavez/performersmusic', name: 'performersmusic', element: Performersmusic },
    { path: '/high_octavez/auditionenquirymusic', name: 'auditionenquirymusic', element: Auditionenquirymusic },
    { path: '/high_octavez/live', name: 'live', element: Lives },


    // Admin role routes
    { path: '/admin/dashboard', name: 'dashboard', element2: Dashboard },
    { path: '/admin/adminproject', name: 'Adminproject', element2: Adminproject },
    { path: '/admin/adminevents', name: 'Adminevents', element2: Adminevents },
    { path: '/admin/admingallery', name: 'Admingallery', element2: Admingallery },
    { path: '/admin/adminnews', name: 'Adminnews', element2: Adminnews },
    { path: '/admin/adminperformer', name: 'Adminperformer', element2: Adminperformer },
    { path: '/admin/adminuser', name: 'Adminuser', element2: Adminuser },
    { path: '/admin/adminuserrole', name: 'Userole', element2: Userole },
    { path: '/admin/adminaccessrights', name: 'Adminaccessrights', element2: accessrights },
    { path: '/admin/booking', name: 'Booking', element2: Booking },
    { path: '/admin/auditionenquiry', name: 'Auditionenquiry', element2: Auditionenquiry },
    { path: '/admin/transactiondetails', name: 'Transactiondetials', element2: Transactiondetials },
    { path: '/admin/incomeexpenses', name: 'Transactiondetials', element2: Incomeexpenses },
    { path: '/admin/adminreport', name: 'Report', element2: Adminreport },
    { path: '/admin/adminmessage', name: 'UserMessage', element2: Adminmessage },
    { path: '/admin/AdminReachUs', name: 'ReachUs', element2: AdminReachUs },
    { path:'/admin/Adminkarunagallery',name:'Adminkarunagallery',element2:Adminkarunagallery},
    { path: '/admin/AdminLetter', name: 'News', element2: AdminNewsLetters },
    { path: '/admin/KarunaLetter', name: 'News', element2: KarunaNewsLetters },
    {path:'/admin/admindonation',name:'AdminDonation',element2:Admindonation},
    {path:'/admin/karunamessage',name:'KarunaMessage',element2:AdminKarunamessage},
    {path:'/admin/taxation',name:'Admintaxation',element2:Admintaxation},
    {path:'/admin/summary',name:'Admintaxation',element2:Adminsummary},
    {path:'/admin/logview',name:'Adminlogview',element2:Adminlogview},
    {path:'/admin/deletedlog',name:'Admindeletedlog',element2:Admindeletedlog},
    {path:'/admin/report',name:'Adminreport',element2:AdminReport},
    {path:'/admin/titleconfig',name:'AdminTitleConfig',element2:AdminTitleConfig},
    {path:'/admin/contactconfig',name:'AdminContactInfo',element2:AdminContactInfo},
    {path:'/admin/profile',name:'AdminContactInfo',element2:AdminProfile},

];


export default routes